/* eslint-disable @typescript-eslint/restrict-template-expressions */
import React, { useCallback, useEffect, useState } from 'react'
import Select from 'react-select'
import ScreenSearchDesktopIcon from '@mui/icons-material/ScreenSearchDesktop'
import {
  Heart,
  MessageCircle,
  Repeat2,
  Share,
  MoreHorizontal,
  Check,
  Copy,
  ExternalLink,
} from 'lucide-react'
import {
  Box,
  Modal,
  Typography,
  Alert,
  Button,
  CircularProgress,
  Divider,
  List,
  ListItem,
  ListItemText,
} from '@mui/material'
import {
  Exact,
  GetHitsQuery,
  Hit,
  HitFilter,
  InputMaybe,
  Sort,
  useInteractedWithHitMutation,
  useArchiveHitMutation,
  Platform,
  useGetResponseLazyQuery,
  useCreateHitGenerationMutation,
  useUpdateCampaignResultsMutation,
  useGetRefreshContentInfoQuery,
  useGetPlatformsQuery,
  GetHitsQueryVariables,
  useGetHitsQuery,
  useBulkGenerateSummaryMutation,
  useGetBulkGenerateSummaryVibeQuery,
  useGetVibesQuery,
  useGetActiveWeeklyContextQuery,
} from 'graphql/generated/graphql'
import TableStyle from 'pages/Campaigns/components/CampaignsView/components/BasicTable/Style'
import { ApolloQueryResult } from '@apollo/client'
import EmptyState from 'components/EmptyState/EmptyState'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import HitsTableScrapingStatus from './HitsTableScrapingStatus'
import ClassificationMultiSelect from './ClassificationMultiSelect'
import {
  CommentCard,
  CommentHeader,
  ProfileImage,
  CommentContent,
  UserHandle,
  TimeStamp,
  CommentText,
  ReplyButton,
  ReplyIcon,
  CommentSection,
  CommentInput,
  ReplyButtons,
  ReplySection,
  GenerateButton,
  HashTag,
  SummaryText,
  SummaryDetailsText,
  SocialStats,
} from './StyleHitTable'
import { Icons } from 'constants/icon'
import { DEFAULT_AVATAR_URL } from 'components/HitCard/Utils'
import SocialMediaIcon from 'components/SocialMediaIcon/SocialMediaIcon'
import { format } from 'date-fns'
import { shortenString } from 'utils/shortenString'
import { Colors } from 'constants/colors'
import ErrorIcon from '@mui/icons-material/Error'
import axios from 'axios'
import CloseIcon from '@mui/icons-material/Close'
import HitModalStyle from 'components/HitDetailsModal/Style'
import { formatLongNumber } from 'utils/number'
import OpenAI from 'openai'
import { Loading } from '../../../graphql/generated/graphql'
import zIndex from '@mui/material/styles/zIndex'
import MultiSelect from 'components/Multiselect/Multiselect'
import Spinner from 'components/Spinner/Spinner'
import { useNalapodExtension } from 'hooks/useNalapodExtension'


import { LOCAL, DEVELOP } from 'constants/env'
import { COMMENT_STYLES, CommentStyle } from 'constants/commentStyles'

interface ResponseType {
  comment1: string
  comment2: string
  comment3: string
}

interface HitTableRow {
  data: GetHitsQuery
  refetch: (
    variables?:
      | Partial<
          Exact<{
            filter: HitFilter
            sort?: InputMaybe<Sort> | undefined
          }>
        >
      | undefined
  ) => Promise<ApolloQueryResult<GetHitsQuery>>
  campaignId: number
  networkFilter: string
  setNetworkFilter: React.Dispatch<React.SetStateAction<string>>
  sortBy: string
  setSortBy: React.Dispatch<React.SetStateAction<string>>
  statusData: {
    instagram: boolean
    youtube: boolean
    reddit: boolean
    tiktok: boolean
    facebook: boolean
  }
  classificationTag: string[]
  setClassificationTag: React.Dispatch<React.SetStateAction<string[]>>
  newData: Hit[]
  hitGenerationCounts: Record<string, number>
  setHitGenerationCounts: React.Dispatch<
    React.SetStateAction<Record<string, number>>
  >
  categories: string[]
  filterPlatforms: string[]
  setFilterPlatforms: React.Dispatch<React.SetStateAction<any>>
  setCategories: React.Dispatch<React.SetStateAction<any>>
  setIsHideContent: React.Dispatch<React.SetStateAction<boolean>>
  setLikes: React.Dispatch<React.SetStateAction<any>>
  generatedComments: Record<string, string>
  setGeneratedComments: React.Dispatch<
    React.SetStateAction<Record<string, string>>
  >
  likes: string[]
  isHideContent: boolean
}
const scrapingText =
  "We're fetching campaign results, please check back in 2 minutes."
const emptyStateText =
  "Try adjusting your filter to find what you're looking for"


export default function HitsTable(props: HitTableRow): JSX.Element {
  const [checked] = React.useState(true)
  const params = useParams()
  const [isRepliedModalOpen, setIsRepliedModalOpen] = useState<boolean>(false)
  const [addInteraction] = useInteractedWithHitMutation()
  const [addArchive] = useArchiveHitMutation()
  const [value, setValue] = React.useState('')
  const [loading, setIsLoading] = React.useState(false)
  const [errorMessage, setErrorMessage] = React.useState<null | string>(null)
  const [currentItemId, setCurrentItemId] = useState<Hit | null>(null)
  const [youtubeHits, setYoutubeHits] = React.useState<any[]>([])
  const [redditHits, setRedditHits] = React.useState<any[]>([])
  const [openRefreshModal, setOpenRefreshModal] = useState(false)
  const [finalMessageState, setFinalMessageState] = useState<
    'Refreshing' | 'Too early'
  >('Refreshing')
  const [finalMessageModal, setFinalMessageModal] = useState(false)
  const [platforms1, setPlatforms] = useState<Platform[]>([])
  const [open, setOpen] = useState<string | null>(null)
  const menuRef = React.useRef<HTMLDivElement | null>(null)
  const buttonRef = React.useRef<HTMLButtonElement>(null)
  const navigate = useNavigate()
  const location = useLocation()
  const [interactedOnly, setInteractedOnly] = React.useState(false)
  const [getResponse, { loading: responseLoading, error, data }] =
    useGetResponseLazyQuery()
  const [responses, setResponses] = React.useState<ResponseType | undefined>()
  const [shareCopiedStates, setShareCopiedStates] = useState<boolean[]>([])
  const [generateCommentLoader, setGenerateCommentLoader] =
    useState<boolean>(false)
  const [copiedStates, setCopiedStates] = useState<boolean[]>([])
  const [summaries, setSummaries] = useState<Record<string, string>>({})
  const [generatingComment, setGeneratingComment] = useState<
    Record<string, boolean>
  >({})
  const { generatedComments, setGeneratedComments } = props
  // const [generatedComments, setGeneratedComments] = useState<
  //   Record<string, string>
  // >({})
  // console.log('generatedComments-----------', generatedComments)
  const [hits, setHits] = useState<Hit[]>(props?.data?.hits?.hits ?? [])

  // Add these new state variables near your existing useState declarations
  const [isEditModalOpen, setIsEditModalOpen] = useState<boolean>(false)
  const [editingCommentId, setEditingCommentId] = useState<string | null>(null)
  const [editValue, setEditValue] = useState('')
  const [editErrorMessage, setEditErrorMessage] = useState<null | string>(null)
  const [editLoading, setEditLoading] = useState(false)
  const [bulkReplyLoading, setBulkReplyLoading] = React.useState(false)
  const [comments, setComments] = useState<string[]>([])
  const [lastComments, setLastComments] = useState<string[]>([])
  const [isLoadings, setIsLoadings] = useState(false)
  const [errorMessages, setErrorMessages] = useState('')
  const [bulkProgress, setBulkProgress] = useState<string | null>(null)

  const [selectedStyle, setSelectedStyle] = useState<CommentStyle>(() => {
    try {
      const stored = localStorage.getItem(`commentStyle_${params.campaignId}`)
      if (stored && Object.keys(COMMENT_STYLES).includes(stored)) {
        return stored as CommentStyle
      }
      return 'casual'
    } catch {
      return 'casual'
    }
  })
  const { openInstagramReply, checkInstalled, checkRateLimit } = useNalapodExtension();

// Load comments on mount - runs once
useEffect(() => {
  try {
    const stored = localStorage.getItem(`generatedComments_${params.campaignId}`)
    if (stored) {
      const savedComments = JSON.parse(stored)
      setGeneratedComments(savedComments) // Replace, don't merge
    }
  } catch (error) {
    console.error('Error loading saved comments:', error)
  }
  // eslint-disable-next-line react-hooks/exhaustive-deps
}, [params.campaignId]) // Only run when campaignId changes

// Save comments whenever they change
useEffect(() => {
  if (Object.keys(generatedComments).length > 0) {
    try {
      localStorage.setItem(
        `generatedComments_${params.campaignId}`,
        JSON.stringify(generatedComments)
      )
    } catch (error) {
      console.error('Error saving comments:', error)
    }
  }
}, [generatedComments, params.campaignId])

  console.log(generatedComments, 'generatedComments')
  // Add this function to handle edit save
  // const handleEditSave = useCallback(async () => {
  //   if (!editingCommentId || editValue.trim().length === 0) return

  //   setEditLoading(true)

  //   try {
  //     // Update the generated comment
  //     setGeneratedComments((prev) => ({
  //       ...prev,
  //       [editingCommentId]: editValue.trim(),
  //     }))
  //     const allComments = Object.values({
  //       ...generatedComments,
  //       [editingCommentId]: editValue,
  //     })

  //     const commentsToSend =
  //       allComments.length > 20 ? allComments.slice(-20) : allComments

  //     await bulkGenerateSummary({
  //       variables: {
  //         campaignId: params.campaignId ?? '',
  //         data: JSON.stringify(commentsToSend),
  //       },
  //     })
  //     // Close modal and reset states
  //     setIsEditModalOpen(false)
  //     setEditingCommentId(null)
  //     setEditValue('')
  //     setEditErrorMessage(null)
  //   } catch (error) {
  //     setEditErrorMessage('Failed to save comment. Please try again.')
  //   } finally {
  //     setEditLoading(false)
  //   }
  // }, [editingCommentId, editValue, setGeneratedComments])

  const handleEditSave = useCallback(async () => {
    if (!editingCommentId || editValue.trim().length === 0) return

    setEditLoading(true)

    try {
      // 1. Build updated comments safely using functional updater
      let updatedComments: Record<string, string> = {}
      setGeneratedComments((prev) => {
        updatedComments = {
          ...prev,
          [editingCommentId]: editValue.trim(),
        }
        return updatedComments
      })

      // 2. Prepare last 20 comments
      // const commentsToSend =
      //   // Object.values(updatedComments).length > 20
      //   //   ? Object.values(updatedComments).slice(-20)
      //   // :
      //   Object.values(updatedComments)

      const commentsToSend = {
        editedId: editingCommentId,
        comments: Object.values(updatedComments),
      }

      // 3. Send to backend
      await bulkGenerateSummary({
        variables: {
          campaignId: params.campaignId ?? '',
          data: JSON.stringify(commentsToSend),
        },
      })

      // 4. Close modal and reset states
      setIsEditModalOpen(false)
      setEditingCommentId(null)
      setEditValue('')
      setEditErrorMessage(null)
    } catch (error) {
      console.error(error)
      setEditErrorMessage('Failed to save comment. Please try again.')
    } finally {
      setEditLoading(false)
    }
  }, [editingCommentId, editValue, setGeneratedComments])

  const handleEditComment = useCallback(
    (hitId: string, currentComment: string) => {
      setEditingCommentId(hitId)
      setEditValue(currentComment)
      setIsEditModalOpen(true)
    },
    []
  )

  const platforms = [
    'all',
    'Instagram',
    'TikTok',
    'Youtube',
    'Reddit',
    'Facebook',
  ]
  const categoriesList = [
    // { value: 'all', label: 'All' },
    { value: 'business', label: 'Business' },
    { value: 'sports', label: 'Sports' },
    { value: 'video games', label: 'Video games' },
    { value: 'technology', label: 'Technology' },
    { value: 'software', label: 'Software' },
    { value: 'electronics', label: 'Electronics' },
    { value: 'fashion', label: 'Fashion' },
    { value: 'beauty', label: 'Beauty' },
    { value: 'fitness', label: 'Fitness' },
    { value: 'food', label: 'Food' },
    { value: 'comedy', label: 'Comedy' },
    { value: 'history', label: 'History' },
    { value: 'crime', label: 'Crime' },
    { value: 'music', label: 'Music' },
    { value: 'wellness', label: 'Wellness' },
    { value: 'miscellaneous', label: 'Miscellaneous' },
    { value: 'animal', label: 'Animal' },
  ]

  const likesOptions = [
    // { value: 'all', label: 'All' },
    { value: '0-100', label: '0–100' },
    { value: '101-500', label: '101–500' },
    { value: '501-1,000', label: '501–1,000' },
    { value: '1,001-5,000', label: '1,001–5,000' },
    { value: '5,001-10,000', label: '5,001–10,000' },
    { value: '10,001-50,000', label: '10,001–50,000' },
    { value: '50,001-100,000', label: '50,001–100,000' },
    { value: '100,001+', label: '100,001+' },
  ]
  const { data: PlatformsData } = useGetPlatformsQuery({
    variables: {
      id: props.campaignId,
    },
  })

  useEffect(() => {
    try {
      localStorage.setItem(`commentStyle_${params.campaignId}`, selectedStyle)
    } catch (error) {
      console.error('Error saving comment style:', error)
    }
  }, [selectedStyle, params.campaignId])

  useEffect(() => {
    setPlatforms(PlatformsData?.platforms ?? [])
  }, [PlatformsData])

  const {
    loading: getCommentsLoading,
    error: commentsError,
    data: commentsData,
    refetch: refetchComments,
  } = useGetVibesQuery({
    variables: {
      campaignId: Number(params.campaignId), // or your actual campaign id
    },
  })
  console.log('🚀 ~ HitsTable ~ commentsData:', commentsData)

  // useEffect(() => {
  //   if (active) {
  //     void refetchComments()
  //   }
  // }, [active, refetchComments])

  useEffect(() => {
    if (commentsData?.getVibes) {
      setLastComments(commentsData.getVibes.map((vibe) => vibe.comment))
    }
  }, [commentsData]) 

  function formatNumber(num: number): string {
    if (num >= 1_000_000_000) {
      return (num / 1_000_000_000).toFixed(1).replace(/\.0$/, '') + 'B'
    }
    if (num >= 1_000_000) {
      return (num / 1_000_000).toFixed(1).replace(/\.0$/, '') + 'M'
    }
    if (num >= 1_000) {
      return (num / 1_000).toFixed(1).replace(/\.0$/, '') + 'K'
    }
    return num.toString()
  }
  // const [hitGenerationCounts, setHitGenerationCounts] = useState<
  //   Record<string, number>
  // >({})
  const [vibes, setVibes] = useState<string[]>([])

  // const {
  //   loading: getVibeLoading,
  //   error: vibeError,
  //   data: vibeData,
  //   refetch,
  // } = useGetAllVibesQuery({
  //   skip: !active,
  // })

  // useEffect(() => {
  //   if (active) {
  //     void refetch()
  //   }
  // }, [active, refetch])

  // useEffect(() => {
  //   if (vibeData?.getAllVibes) {
  //     setVibes([...vibeData.getAllVibes])
  //   }
  // }, [vibeData])

  const [commentLoading, setCommentLoading] = useState<boolean>(false)
  const [createHitGeneration] = useCreateHitGenerationMutation()

  const copyToClipboard = useCallback(
    async (text: string, index: number) => {
      try {
        await navigator.clipboard.writeText(text)
        const newCopiedStates = [...copiedStates]
        newCopiedStates[index] = true
        setCopiedStates(newCopiedStates)
        setTimeout(() => {
          const newCopiedStatesTimeout = [...copiedStates]
          newCopiedStatesTimeout[index] = false
          setCopiedStates(newCopiedStatesTimeout)
        }, 2000)
      } catch (err: any) {
        console.error('Failed to copy text: ', err)
        // Handle error appropriately (e.g., show an error message)
      }
    },
    [copiedStates, setCopiedStates]
  )

  const shareCopyToClipboard = useCallback(
    async (text: string, index: number) => {
      try {
        await navigator.clipboard.writeText(text)
        const newCopiedStates = [...shareCopiedStates]
        newCopiedStates[index] = true
        setShareCopiedStates(newCopiedStates)
        setTimeout(() => {
          const newCopiedStatesTimeout = [...shareCopiedStates]
          newCopiedStatesTimeout[index] = false
          setShareCopiedStates(newCopiedStatesTimeout)
        }, 2000)
      } catch (err: any) {
        console.error('Failed to copy text: ', err)
        // Handle error appropriately (e.g., show an error message)
      }
    },
    [shareCopiedStates, setShareCopiedStates]
  )

  const buttonclickHandler = (item: any) => {
    if (item.interactedWith) return
    if (['Instagram', 'Facebook', 'TikTok'].includes(item.platforms[0])) {
      if (!item.interactedWith) {
        addInteraction({
          variables: {
            campaignId: params.campaignId ?? '',
            hitId: item.id,
          },
        }).catch((e) => {
          console.log(e)
        })
      }
      window.open(item.postURL, '_blank')
    } else {
      setCurrentItemId(item)
      setIsRepliedModalOpen(!isRepliedModalOpen)
    }
  }
  const getParamsObj = (
    title: string,
    value: string
  ): {
    network?: string | undefined
    sort?: string | undefined
  } => {
    if (title === 'network') {
      return {
        ...(props.sortBy === 'default' ? {} : { sort: props.sortBy }),
        ...(value === 'all' ? {} : { network: value }),
      }
    } else if (title === 'sort') {
      return {
        ...(value === 'default' ? {} : { sort: value }),
        ...(props.networkFilter === 'all'
          ? {}
          : { network: props.networkFilter }),
      }
    } else {
      return {
        ...(props.sortBy === 'default' ? {} : { sort: props.sortBy }),
        ...(props.networkFilter === 'all'
          ? {}
          : { network: props.networkFilter }),
      }
    }
  }
  const newFilterChange = (value: string): void => {
    props.setNetworkFilter(value)
    const params = getParamsObj('network', value)
    if (Object.keys(params).length === 0) {
      navigate(`${location.pathname}`)
    } else {
      const sq = '?' + new URLSearchParams(params).toString()
      navigate(`${location.pathname}${sq}`)
    }
  }
  const newSortChange = (value: string): void => {
    props.setSortBy(value)
    const params = getParamsObj('sort', value)
    if (Object.keys(params).length === 0) {
      navigate(`${location.pathname}`)
    } else {
      const sq = '?' + new URLSearchParams(params).toString()
      navigate(`${location.pathname}${sq}`)
    }
  }
    
  const handleRespond = (currentItem: Hit | null): void => {
    console.log('🔴 handleRespond called with:', currentItem);
    
    if (!currentItem) return;
    
    const platform = currentItem.platforms[0];
    
    if (platform === 'Youtube') return respondYoutube(currentItem);
    if (platform === 'Reddit') return respondReddit(currentItem);
    
    // If we get here, something went wrong
    console.error('❌ Unexpected platform in handleRespond:', platform);
  };


  const [bulkGenerateSummary, { loading: vibeLoading }] =
    useBulkGenerateSummaryMutation()

  const extractComments = (redditResponse: any): string[] => {
    return (
      redditResponse.data?.data?.children?.map(
        (child: any) => child.data.body
      ) ?? []
    )
  }

  const allCommentsReddit = async (): Promise<void> => {
    try {
      setIsLoadings(true)

      const accessToken = localStorage.getItem('reddit_access_token')
      if (!accessToken) throw new Error('No Reddit access token found')

      // Get username
      const meResponse = await axios.get('https://oauth.reddit.com/api/v1/me', {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          'User-Agent': 'Nalopod v1 (by u/Dazzling_Price_5207)',
          // 'User-Agent': 'Nalopod v1 (by u/Zealousideal-Lock543)',
        },
      })
      const username = meResponse.data.name

      // Fetch last 20 comments
      const commentsResponse = await axios.get(
        `https://oauth.reddit.com/user/${username}/comments?limit=20`,
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
            'User-Agent': 'Nalopod v1 (by u/Dazzling_Price_5207)',
            // 'User-Agent': 'Nalopod v1 (by u/Zealousideal-Lock543)',
          },
        }
      )

      const extractedComments = extractComments(commentsResponse)
      setComments(extractedComments)
      setIsLoadings(false)
    } catch (e: any) {
      setIsLoadings(false)
      if (e.response) {
        if (e.response.status === 401) {
          setErrorMessages(
            'Please connect your Reddit account before fetching comments.'
          )
        } else {
          setErrorMessages(
            e.response.data?.message ??
              'Something went wrong. Please try again later.'
          )
        }
      } else {
        setErrorMessages(
          'An unexpected error occurred. Please try again later.'
        )
      }
      console.error(e)
    }
  }

  useEffect(() => {
    // Call the async function inside useEffect
    const fetchComments = async () => {
      await allCommentsReddit()
    }
    void fetchComments()
  }, [])

  useEffect(() => {
    if (comments.length === 0) return

    const saveComments = async () => {
      try {
        await bulkGenerateSummary({
          variables: {
            campaignId: '',
            data: JSON.stringify(comments),
          },
        })
        console.log('Comments saved successfully!')
      } catch (err) {
        console.error('Error saving comments:', err)
      }
    }

    void saveComments()
  }, [comments, bulkGenerateSummary])

  const respondReddit = (currentItemId: Hit | null): void => {
    setIsLoading(true)
    const accessToken = localStorage.getItem('reddit_access_token')
    const url = 'https://oauth.reddit.com/api/comment'
    const data = {
      thing_id: `t3_${currentItemId?.id}`,
      text: value,
      api_type: 'json',
    }
    const headers = {
      'Content-Type': 'application/x-www-form-urlencoded',
      Authorization: `bearer ${accessToken ?? ''}`,
      'User-Agent': 'Nalopod v1 (by u/Dazzling_Price_5207)',
      // 'User-Agent': 'Nalopod v1 (by u/Zealousideal-Lock543)',
    }
    axios
      .post(url, data, {
        headers,
      })
      .then(async (res) => {
        if (!currentItemId?.interactedWith) {
          await addInteraction({
            variables: {
              campaignId: currentItemId?.campaignId ?? '',
              hitId: currentItemId?.id ?? '',
            },
          })
        }

        setHits((prev) =>
          prev.map((hit) =>
            hit.id === currentItemId?.id
              ? { ...hit, interactedWith: true }
              : hit
          )
        )

        setIsLoading(false)
        setValue('')
        setErrorMessage(null)
        setCurrentItemId(null)
        setIsRepliedModalOpen(false)
      })
      .catch((e) => {
        if (e.response) {
          if (e.response.status === 401) {
            setErrorMessage(
              'Please connect your socials before replying to this hit. To connect your socials, go to "Connect Social" section in our app.'
            )
          } else {
            setErrorMessage(
              e.response.data.message ??
                'Something went wrong please try again later.'
            )
          }
        } else {
          setErrorMessage(
            'An unexpected error occurred. Please try again later.'
          )
        }
        setIsLoading(false)
        console.error(e)
      })
  }

  const respondYoutube = (currentItemId: Hit | null): void => {
    setIsLoading(true)
    const accessToken = localStorage.getItem('google_access_token')
    // console.log(accessToken, 'opopopopopopop')

    const url =
      'https://www.googleapis.com/youtube/v3/commentThreads?part=id,snippet'
    const data = {
      snippet: {
        videoId: currentItemId?.id,
        topLevelComment: {
          snippet: {
            textOriginal: value,
          },
        },
      },
    }
    const headers = {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${accessToken ?? ''}`,
    }
    axios
      .post(url, JSON.stringify(data), {
        headers,
      })
      .then(async (res) => {
        if (!currentItemId?.interactedWith) {
          await addInteraction({
            variables: {
              campaignId: currentItemId?.campaignId ?? '',
              hitId: currentItemId?.id ?? '',
            },
          })
        }

        setHits((prev) =>
          prev.map((hit) =>
            hit.id === currentItemId?.id
              ? { ...hit, interactedWith: true }
              : hit
          )
        )

        setIsLoading(false)
        setValue('')
        setErrorMessage(null)
        setCurrentItemId(null)
        setIsRepliedModalOpen(false)
      })
      .catch((e) => {
        if (e.response) {
          if (e?.response?.status === 401) {
            setErrorMessage(
              'Please connect your socials before replying to this hit. To connect your socials, go to "Connect Social" section in our app.'
            )
          } else {
            setErrorMessage(
              e.response.data.message ??
                'Something went wrong please try again later.'
            )
          }
        } else {
          setErrorMessage(
            'An unexpected error occurred. Please try again later.'
          )
        }
        setIsLoading(false)
        console.error(e)
      })
  }

  const respondRedditBulk = async (
    hit: Hit,
    comment: string,
  ): Promise<{ success: boolean; error?: string }> => {
    try {
  
      const accessToken = localStorage.getItem('reddit_access_token')
      const url = 'https://oauth.reddit.com/api/comment'
      const data = {
        thing_id: `t3_${hit.id}`,
        text: comment,
        api_type: 'json',
      }
      const headers = {
        'Content-Type': 'application/x-www-form-urlencoded',
        Authorization: `bearer ${accessToken ?? ''}`,
        'User-Agent': 'Nalapod v1 (by u/Dazzling_Price_5207)',
      }
  
      const response = await axios.post(url, data, { headers })
  
      // Mark as interacted if not already
      if (!hit.interactedWith) {
        await addInteraction({
          variables: {
            campaignId: hit.campaignId ?? '',
            hitId: hit.id,
          },
        })
      }
  
      // ✅ UPDATE LOCAL STATE IMMEDIATELY
      setHits((prev) =>
        prev.map((h) => (h.id === hit.id ? { ...h, interactedWith: true } : h))
      )
  
      return { success: true }
    } catch (error: any) {
      // Handle specific Reddit API errors
      if (error.response?.status === 429) {
        return {
          success: false,
          error: 'Reddit rate limit exceeded. Please slow down.',
        }
      }
      if (error.response?.status === 401) {
        return {
          success: false,
          error: 'Reddit authentication expired. Please reconnect your account.',
        }
      }
      return {
        success: false,
        error: error.response?.data?.message || 'Reddit reply failed',
      }
    }
  }

  const respondYoutubeBulk = async (
    hit: Hit,
    comment: string,
  ): Promise<{ success: boolean; error?: string }> => {
    try {
  
      const accessToken = localStorage.getItem('google_access_token')
      const url =
        'https://www.googleapis.com/youtube/v3/commentThreads?part=id,snippet'
      const data = {
        snippet: {
          videoId: hit.id,
          topLevelComment: {
            snippet: {
              textOriginal: comment,
            },
          },
        },
      }
      const headers = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken ?? ''}`,
      }
  
      const response = await axios.post(url, JSON.stringify(data), { headers })
  
      // Mark as interacted if not already
      if (!hit.interactedWith) {
        await addInteraction({
          variables: {
            campaignId: hit.campaignId ?? '',
            hitId: hit.id,
          },
        })
      }
  
      // ✅ UPDATE LOCAL STATE IMMEDIATELY
      setHits((prev) =>
        prev.map((h) => (h.id === hit.id ? { ...h, interactedWith: true } : h))
      )
  
      return { success: true }
    } catch (error: any) {
      // Handle specific YouTube API errors
      if (error.response?.status === 403) {
        return {
          success: false,
          error: 'YouTube API quota exceeded. Please try again later.',
        }
      }
      if (error.response?.status === 401) {
        return {
          success: false,
          error: 'YouTube authentication expired. Please reconnect your account.',
        }
      }
      return {
        success: false,
        error: error.response?.data?.message || 'YouTube reply failed',
      }
    }
  }
  

  const config = process.env.NODE_ENV === 'development' ? LOCAL : DEVELOP

  const {
    loading: getVibeLoading,
    error: vibeError,
    data: vibeData,
  } = useGetBulkGenerateSummaryVibeQuery()

  // Fetch weekly context for AI comment generation
  const { data: weeklyContextData } = useGetActiveWeeklyContextQuery()

  // Safely parse user vibe (which may be a JSON string or an object)
  let userVibe: { description?: string; examples?: string[] } = {}
  try {
    console.log(userVibe, 'vibeData')
    const rawVibe = vibeData?.getBulkGenerateSummaryVibe

    userVibe = typeof rawVibe === 'string' ? JSON.parse(rawVibe) : rawVibe ?? {}
  } catch (err) {
    console.error('Error parsing userVibe data:', err)
    userVibe = {}
  }

  // Get weekly context for AI generation
  const weeklyContext = weeklyContextData?.getActiveWeeklyContext?.context as {
    books?: string[]
    activities?: string[]
    media?: string[]
    topics?: string[]
    freeform?: string
  } | undefined

  // Clean, focused function
// ✅ REPLACE with this new version that calls your backend
const generateComment = useCallback(
  async (
    hashtags: string[],
    summary: string,
    hitId: string,
    caption: string,
    selectedStyle: CommentStyle = 'casual'
  ) => {
    setCommentLoading(true)
    setGeneratingComment((prev) => ({ ...prev, [hitId]: true }))

    try {
      const response = await fetch(
        `${config.API_URL}/api/generate-comment`, // ← Use your env config
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            hashtags,
            summary,
            caption,
            selectedStyle,
            userVibe: userVibe ?? undefined, // Send userVibe to backend
            weeklyContext: weeklyContext ?? undefined, // Send weekly context to backend
          }),
        }
      )

      if (!response.ok) {
        const errorData = await response.json()
        throw new Error(errorData.error || 'Failed to generate comment')
      }

      const data = await response.json()
      
      if (!data.success || !data.comment) {
        throw new Error('Invalid response from server')
      }

      const message = data.comment.trim()
      
      // ✅ Store successful comment
      setGeneratedComments((prev) => ({ ...prev, [hitId]: message }))
      
      return message
    } catch (error: any) {
      console.error('Error generating comment:', error)
      
      // ✅ Return null instead of error message (don't store in state)
      return null
    } finally {
      setGeneratingComment((prev) => ({ ...prev, [hitId]: false }))
      setCommentLoading(false)
    }
  },
  [userVibe, weeklyContext, selectedStyle] // Dependencies include weekly context
)

  React.useEffect(() => {
    if (props.newData && props.newData.length > 0) {
      const youtubeData = props.newData?.filter(
        (item) => item.platforms[0] === 'Youtube'
      )
      setYoutubeHits(youtubeData)
      const redditData = props.newData?.filter(
        (item) => item.platforms[0] === 'Reddit'
      )
      setRedditHits(redditData)
    }
  }, [props.newData])

  // Sync when props change
  React.useEffect(() => {
    if (props?.data?.hits?.hits) {
      setHits(props.data.hits.hits)
    }
  }, [props?.data?.hits?.hits])

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        menuRef.current &&
        !menuRef.current.contains(event.target as Node) &&
        buttonRef.current &&
        !buttonRef.current.contains(event.target as Node)
      ) {
        setOpen(null)
      }
    }
    document.addEventListener('mousedown', handleClickOutside)
    return () => document.removeEventListener('mousedown', handleClickOutside)
  }, [setOpen])

  // React.useEffect(() => {
  //   if (data?.respond !== '{}' && data) {
  //     console.log('data?.respond', data?.respond)
  //     const parsed = JSON.parse(data.respond)
  //     setResponses(parsed)
  //   }
  // }, [data])

  React.useEffect(() => {
    if (data?.respond && data.respond !== '{}') {
      console.log('data?.respond', data.respond)

      // Remove ```json ... ``` if present
      const cleaned = data.respond
        .replace(/^```json\s*/, '')
        .replace(/```$/, '')

      try {
        const parsed = JSON.parse(cleaned)
        setResponses(parsed)
      } catch (err) {
        console.error('Failed to parse JSON', err)
      }
    }
  }, [data])

  // React.useEffect(() => {
  //   if (props.newData && props.newData.length > 0) {
  //     const initialCounts: Record<string, number> = {}
  //     props.newData.forEach((item) => {
  //       initialCounts[item.id] = item.generateCount ?? 0
  //     })
  //     props.setHitGenerationCounts(initialCounts)
  //   }
  // }, [props.newData])
  // useEffect(() => {
  //   if (props.newData && props.newData.length > 0) {
  //     props.setHitGenerationCounts((prev) => {
  //       const updated = { ...prev }
  //       props.newData.forEach((item) => {
  //         if (!(item.id in updated)) {
  //           updated[item.id] = item.generateCount ?? 0
  //         }
  //       })
  //       return updated
  //     })
  //   }
  // }, [props.newData])
  React.useEffect(() => {
    if (props.newData && props.newData.length > 0) {
      const localStorageKey = `hitCounts-${props.campaignId}`

      // Step 1: Try to load from localStorage
      const storedCounts = localStorage.getItem(localStorageKey)
      const parsedCounts: Record<string, number> = storedCounts
        ? JSON.parse(storedCounts)
        : {}
      // Step 2: Merge new data (only if not present)
      const updatedCounts: Record<string, number> = { ...parsedCounts }

      props.newData.forEach((item) => {
        if (!(item.id in updatedCounts)) {
          updatedCounts[item.id] = item.generateCount ?? 0
        }
      })
      // Step 3: Update state and localStorage
      props.setHitGenerationCounts(updatedCounts)
      localStorage.setItem(localStorageKey, JSON.stringify(updatedCounts))
    }
  }, [props.newData, props.campaignId])

  React.useEffect(() => {
    const localStorageKey = `hitCounts-${props.campaignId}`
    if (
      props.hitGenerationCounts &&
      Object.keys(props.hitGenerationCounts).length > 0
    ) {
      localStorage.setItem(
        localStorageKey,
        JSON.stringify(props.hitGenerationCounts)
      )
    }
  }, [props.hitGenerationCounts, props.campaignId])

  const { data: refreshContentData } = useGetRefreshContentInfoQuery({
    variables: {
      id: props?.campaignId,
    },
  })

  const [updateCampaignMutation, { loading: updateLoading }] =
    useUpdateCampaignResultsMutation({
      variables: {
        searchRequiermentID: props?.campaignId,
        platforms: platforms1,
        queryTree: refreshContentData?.refreshContentInfo?.queryTree ?? '',
        maxHits: refreshContentData?.refreshContentInfo?.maxHits ?? 0,
      },
    })

  // const [bulkGenerateSummary, { loading: vibeLoading }] =
  //   useBulkGenerateSummaryMutation()

  const baseOptions = (): {
    variables: GetHitsQueryVariables
    notifyOnNetworkStatusChange: boolean
    fetchPolicy: 'network-only'
  } => {
    const campaignId = props.campaignId // now you can use shorthand

    const variables: GetHitsQueryVariables = {
      filter: {
        campaignId,
        // socialNetwork:
      },
    }

    return {
      variables,
      notifyOnNetworkStatusChange: true,
      fetchPolicy: 'network-only',
    }
  }

  const {
    loading: hitsLoading,
    error: hitsError,
    data: hitsData,
    refetch: hitsRefetch,
    networkStatus: hitsNetworkStatus,
  } = useGetHitsQuery(baseOptions())

  const filteredHits =
    hitsData?.hits?.hits?.filter((hit) =>
      hit.platforms.some(
        (platform) =>
          platform.toLowerCase() === 'youtube' ||
          platform.toLowerCase() === 'reddit'
      )
    ) ?? []

    const bulkCommentGeneration = async () => {
      try {
        setGenerateCommentLoader(true)
        const hits = hitsData?.hits?.hits ?? []
    
        // Prepare data for bulk API call
        const commentsToGenerate = hits.map((item) => ({
          hitId: item.id,
          hashtags: item.content?.match(/#\w+/g) ?? [],
          summary: item.summary ?? '',
          caption: item.content ?? '',
        }))
    
        // ✅ Call bulk generation API
        const response = await fetch(
          `${config.API_URL}/api/generate-bulk-comments`, // ← Use your env config
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              comments: commentsToGenerate,
              selectedStyle, // ✅ Send selected style
              userVibe: userVibe ?? undefined, // ✅ Send userVibe
              weeklyContext: weeklyContext ?? undefined, // ✅ Send weekly context
            }),
          }
        )
    
        if (!response.ok) {
          throw new Error('Bulk generation failed')
        }
    
        const data = await response.json()
    
        if (!data.success) {
          throw new Error('Bulk generation failed')
        }
    
        // ✅ Process results - only store successful comments
        const successfulComments: Record<string, string> = {}
        let successCount = 0
        let failCount = 0
    
        data.results.forEach((result: any) => {
          // Update generation count for all items
          const newCount = (props.hitGenerationCounts[result.hitId] ?? 0) + 1
          props.setHitGenerationCounts((prev) => ({
            ...prev,
            [result.hitId]: newCount,
          }))
    
          // Create hit generation record
          void createHitGeneration({
            variables: {
              hitsId: result.hitId,
              campaignId: Number(params.campaignId),
              count: newCount,
            },
          })
    
          // Only store successful comments
          if (result.success && result.comment) {
            successfulComments[result.hitId] = result.comment
            successCount++
          } else {
            failCount++
            console.warn(`Failed to generate comment for hit ${result.hitId}:`, result.error)
          }
        })
    
        // Update state with successful comments only
        setGeneratedComments((prev) => ({
          ...prev,
          ...successfulComments,
        }))
    
        // Show success message
        if (successCount > 0) {
          alert(`Successfully generated ${successCount} comments${failCount > 0 ? ` (${failCount} failed)` : ''}`)
        } else {
          alert('Failed to generate any comments. Please try again.')
        }
    
        // Save to backend for vibe analysis
        if (Object.keys(successfulComments).length > 0) {
          const commentsForVibe = Object.entries(successfulComments).map(([id, comment]) => ({
            id,
            comment,
          }))
    
          await bulkGenerateSummary({
            variables: {
              campaignId: params.campaignId ?? '',
              data: JSON.stringify(commentsForVibe),
            },
          })
        }
    
        setGenerateCommentLoader(false)
      } catch (error) {
        console.error('Bulk generation error:', error)
        alert('Failed to generate comments. Please try again.')
        setGenerateCommentLoader(false)
      }
    }

    const giveBulkReply = async () => {
      try {
        setBulkReplyLoading(true)
    
        const hits = hitsData?.hits?.hits ?? []
    
        const filteredHits = hits.filter((hit) =>
          hit.platforms.some(
            (platform) =>
              platform.toLowerCase() === 'youtube' ||
              platform.toLowerCase() === 'reddit'
          )
        )
    
        // Get all hits that have generated comments
        const hitsWithComments = filteredHits.filter(
          (hit) => generatedComments[hit.id] && !hit.interactedWith
        )
    
        if (hitsWithComments.length === 0) {
          alert('All posts have already been replied to!')
          setBulkReplyLoading(false)
          return
        }
    
        // ⚠️ SEQUENTIAL processing with delays - not parallel!
        let successCount = 0
        let errorCount = 0
        const errors: string[] = []
    
        for (let i = 0; i < hitsWithComments.length; i++) {
          const hit = hitsWithComments[i]
          const comment = generatedComments[hit.id]
          const platform = hit.platforms[0]
    
          // Show progress (optional - update a state variable if you want to display this)
          console.log(`Processing ${i + 1} of ${hitsWithComments.length}: ${platform} post`)
          setBulkProgress(`Replying to ${i + 1} of ${hitsWithComments.length}...`) // Add this state if you want UI feedback
    
          try {
            // Add delay BEFORE each comment (except the first one)
            if (i > 0) {
              // Random delay based on platform
              const delay = platform === 'Youtube' 
                ? 8000 + Math.random() * 7000  // 8-15 seconds for YouTube
                : 10000 + Math.random() * 10000 // 10-20 seconds for Reddit
              
              console.log(`⏳ Waiting ${Math.round(delay / 1000)} seconds before next comment...`)
              await new Promise(resolve => setTimeout(resolve, delay))
            }
    
            // Make the API call
            let result
            if (platform === 'Youtube') {
              result = await respondYoutubeBulk(hit, comment)
            } else if (platform === 'Reddit') {
              result = await respondRedditBulk(hit, comment)
            }
    
            if (result?.success) {
              successCount++
              console.log(`✅ Successfully replied to ${platform} post ${i + 1}`)
            } else {
              errorCount++
              errors.push(`${platform}: ${result?.error ?? 'Unknown error'}`)
              console.error(`❌ Failed to reply to ${platform} post:`, result?.error)
            }
          } catch (error: any) {
            errorCount++
            errors.push(`${platform}: ${error.message || 'Unexpected error'}`)
            console.error(`❌ Exception on ${platform} post:`, error)
          }
        }
    
        // Show detailed results
        setBulkProgress(null) // Clear progress message
        
        let message = `Bulk reply complete!\n\n✅ Successful: ${successCount}\n❌ Failed: ${errorCount}`
        
        if (errors.length > 0 && errors.length <= 5) {
          message += `\n\nErrors:\n${errors.join('\n')}`
        } else if (errors.length > 5) {
          message += `\n\nShowing first 5 errors:\n${errors.slice(0, 5).join('\n')}\n... and ${errors.length - 5} more`
        }
        
        alert(message)
        
      } catch (error) {
        console.error('Bulk reply error:', error)
        alert('An error occurred during bulk reply. Please try again.')
      } finally {
        setBulkReplyLoading(false)
        setBulkProgress(null)
      }
    }

  return (
    <>
      <Modal open={openRefreshModal} onClose={() => setOpenRefreshModal(false)}>
        {updateLoading ? (
          <div className="flex items-center justify-center h-screen">
            <Spinner />
          </div>
        ) : (
          <div className="fixed inset-0 flex items-center justify-center z-50">
            {/* Overlay */}
            <div
              className="absolute inset-0 bg-black/40 backdrop-blur-[2px]"
              onClick={() => setOpenRefreshModal(false)}
            />

            {/* Modal Content */}
            <div className="relative w-full max-w-2xl bg-slate-800/60 backdrop-blur-xl border border-purple-500/30 rounded-xl shadow-2xl p-6 flex flex-col items-center gap-6 z-50">
              <h3 className="text-purple-300 font-medium text-lg text-center">
                Please choose for what platforms you want to refresh data.
              </h3>

              {/* MultiSelect */}
              <div className="w-full">
                <MultiSelect
                  id="platforms-select"
                  label=""
                  items={platforms1}
                  onChange={(items) => setPlatforms(items)}
                  selectedItems={platforms1}
                />
              </div>

              {/* Buttons */}
              <div className="flex w-full gap-3">
                <button
                  onClick={() => setOpenRefreshModal(false)}
                  className="w-full bg-slate-700/50 border border-red-500/30 text-red-400 rounded-lg px-4 py-2 text-sm font-medium hover:bg-red-500/20 transition-colors cursor-pointer"
                >
                  Cancel
                </button>
                <button
                  onClick={() => {
                    updateCampaignMutation()
                      .then(() => {
                        setOpenRefreshModal(false)
                        setFinalMessageState('Refreshing')
                        setFinalMessageModal(true)
                      })
                      .catch((e) => console.error(e))
                  }}
                  className="w-full bg-gradient-to-r from-purple-600 to-pink-600 text-white px-4 py-2 rounded-lg text-sm font-medium hover:from-purple-500 hover:to-pink-500 transition-all shadow-lg cursor-pointer"
                >
                  Confirm
                </button>
              </div>
            </div>
          </div>
        )}
      </Modal>
      {/* <Fade in={checked} timeout={1500}> */}

      <div
        className="min-h-screen bg-gradient-to-br from-slate-900 via-purple-900 to-slate-900 flex"
        style={{ width: '100%' }}
      >
        <div className="px-6 py-6 flex-1">
          <div className="max-w-5xl mx-auto">
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
              <div className="lg:col-span-3">
                <div className="bg-slate-800/60 backdrop-blur-xl rounded-xl shadow-xl border border-purple-500/20 p-4 mb-6">
                  <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between mb-4 gap-3">
                    <h3 className="text-purple-300 font-medium">Filters</h3>

                    <div className="flex flex-wrap items-center gap-2 lg:gap-4">
                      {/* Comment Style Dropdown */}
                      <div className="flex items-center space-x-2">
                        <label
                          htmlFor="comment-style"
                          className="text-gray-300 text-xs lg:text-sm whitespace-nowrap"
                        >
                          Style:
                        </label>
                        <select
                          id="comment-style"
                          value={selectedStyle}
                          onChange={(e) =>
                            setSelectedStyle(e.target.value as CommentStyle)
                          }
                          className="bg-slate-700/50 border border-purple-500/30 rounded-lg px-2 py-1
                                    text-gray-100 text-xs lg:text-sm hover:bg-purple-600/30 transition-colors
                                    focus:outline-none focus:ring-2 focus:ring-purple-500/50 focus:border-purple-400
                                    min-w-[120px]"
                        >
                          {Object.entries(COMMENT_STYLES).map(
                            ([key, style]) => (
                              <option
                                key={key}
                                value={key}
                                className="bg-slate-700 text-gray-100"
                              >
                                {style.label}
                              </option>
                            )
                          )}
                        </select>
                      </div>

                      <div className="flex flex-wrap gap-2">
                        <button
                          type="button"
                          className="cursor-pointer bg-slate-700/50 border border-purple-500/30 rounded-lg px-3 py-1 text-gray-100 text-xs
                         lg:text-sm hover:bg-purple-600/30 transition-colors
                         disabled:bg-slate-400/30 disabled:text-gray-300
    disabled:cursor-not-allowed"
                          onClick={() => {
                            void bulkCommentGeneration()
                          }}
                          disabled={
                            generateCommentLoader ||
                            filteredHits.every(
                              (hit) =>
                                (props.hitGenerationCounts[hit.id] ?? 0) >= 3
                            )
                          }
                        >
                          {generateCommentLoader
                            ? 'Generating...'
                            : 'Generate Bulk Comments'}
                        </button>
                        <button
                          type="button"
                          className="bg-slate-700/50 border border-purple-500/30 rounded-lg px-3 py-1 
  text-gray-100 text-xs lg:text-sm hover:bg-purple-600/30 transition-colors disabled:bg-slate-400/30 disabled:text-gray-300
    disabled:cursor-not-allowed"
                          // onClick={giveBulkReply}
                          onClick={() => {
                            void giveBulkReply()
                          }}
                          disabled={
                            loading ||
                            Object.keys(generatedComments || {}).length === 0 ||
                            !Object.keys(generatedComments || {}).some(
                              (hitId) => {
                                const hit = hits.find((h) => h.id === hitId)
                                return (
                                  hit &&
                                  (hit.platforms[0] === 'Youtube' ||
                                    hit.platforms[0] === 'Reddit')
                                )
                              }
                            )
                          }
                        >
                          {bulkReplyLoading ? 'Replying...' : 'Bulk Reply'}
                        </button>
                        <button
                          type="button"
                          className="bg-gradient-to-r from-cyan-600 to-blue-600 border border-cyan-500/30 rounded-lg px-3 py-1 
                        text-gray-100 text-xs lg:text-sm hover:from-cyan-500 hover:to-blue-500 transition-colors cursor-pointer"
                          onClick={() =>
                            navigate(
                              `/campaigns/${params.campaignId}/interactions`
                            )
                          }
                        >
                          View Analytics
                        </button>
                      </div>
                    </div>
                  </div>
                  <div className="grid grid-cols-2 lg:grid-cols-5 gap-4">
                    <div className="flex items-center space-x-2">
                      <button
                        onClick={() =>
                          props.setIsHideContent(!props.isHideContent)
                        }
                        className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors ${
                          props.isHideContent
                            ? 'bg-gradient-to-r from-purple-600 to-pink-600'
                            : 'bg-slate-600'
                        }`}
                      >
                        <span
                          className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${
                            props.isHideContent
                              ? 'translate-x-6'
                              : 'translate-x-1'
                          }`}
                        />
                      </button>
                      <span className="text-xs lg:text-sm text-gray-300">
                        Marked Done
                      </span>
                    </div>
                    <div className="col-span-2 lg:col-span-1 relative z-50">
                      <label className="block text-xs lg:text-sm text-gray-300 mb-1">
                        Refresh
                      </label>
                      <button
                        type="button"
                        onClick={() => setOpenRefreshModal(true)}
                        className="w-full bg-slate-700/50 border border-purple-500/30 rounded-lg px-3 py-2 text-gray-100 text-xs lg:text-sm focus:outline-none focus:ring-2 focus:ring-purple-500 hover:bg-purple-600/30 transition-colors cursor-pointer"
                      >
                        Refresh Content
                      </button>
                    </div>

                    <div className="col-span-2 lg:col-span-1 relative z-50">
                      <label className="block text-xs lg:text-sm text-gray-300 mb-1">
                        Likes
                      </label>

                      <Select
                        isMulti
                        options={likesOptions}
                        value={likesOptions.filter(
                          (opt) =>
                            Array.isArray(props.likes) &&
                            props.likes.includes(opt.value)
                        )}
                        onChange={(selected: any) =>
                          props.setLikes(
                            selected ? selected.map((s: any) => s.value) : []
                          )
                        }
                        classNamePrefix="likes"
                        menuPortalTarget={document.body}
                        menuPosition="fixed"
                        styles={{
                          menuPortal: (base: any) => ({
                            ...base,
                            zIndex: 9999,
                          }),
                          control: (base: any) => ({
                            ...base,
                            backgroundColor: 'rgba(51,65,85,0.5)',
                            borderColor: 'rgba(168,85,247,0.3)',
                            borderRadius: '0.5rem',
                            padding: '2px',
                            color: '#fff',
                          }),
                          multiValue: (base: any) => ({
                            ...base,
                            backgroundColor: 'rgba(168,85,247,0.2)',
                          }),
                          multiValueLabel: (base: any) => ({
                            ...base,
                            color: '#d8b4fe',
                          }),
                          multiValueRemove: (base: any) => ({
                            ...base,
                            color: '#c084fc',
                            display: 'flex',
                            ':hover': {
                              backgroundColor: '#a855f7',
                              color: 'white',
                            },
                          }),
                          menu: (base: any) => ({
                            ...base,
                            backgroundColor: '#1e293b',
                          }),
                          option: (base: any, { isSelected }: any) => ({
                            ...base,
                            backgroundColor: isSelected
                              ? '#9333ea'
                              : 'transparent',
                            color: isSelected ? 'white' : '#f1f5f9',
                            ':hover': {
                              backgroundColor: '#7e22ce',
                              color: 'white',
                            },
                            zIndex: isSelected ? '999' : '999',
                          }),
                        }}
                      />
                    </div>

                    <div className="col-span-2 lg:col-span-1 ">
                      <label className="block text-xs lg:text-sm text-gray-300 mb-1">
                        Platform
                      </label>
                      <select
                        value={props.networkFilter}
                        onChange={(e) => {
                          const value = e.target.value
                          if (value === 'all') {
                            props.setNetworkFilter('all')
                          } else {
                            props.setNetworkFilter(value)
                          }
                        }}
                        className="w-full bg-slate-700/50 border border-purple-500/30 rounded-lg px-3 py-2 text-gray-100 text-xs lg:text-sm focus:outline-none focus:ring-2 focus:ring-purple-500"
                      >
                        {platforms.map((platform) => (
                          <option
                            key={platform}
                            value={platform}
                            className="bg-slate-700"
                          >
                            {platform === 'all' ? 'All Platforms' : platform}
                          </option>
                        ))}
                      </select>
                    </div>

                    <div className="col-span-2 lg:col-span-1">
                      <label className="block text-xs lg:text-sm text-gray-300 mb-1">
                        Category
                      </label>
                      {/* <select
                        // multiple
                        value={props.categories}
                        onChange={(e) => {
                          const selected = Array.from(
                            e.target.selectedOptions,
                            (option) => option.value
                          )
                          props.setCategories(selected)
                        }}
                        className="w-full bg-slate-700/50 border border-purple-500/30 rounded-lg px-3 py-2 text-gray-100 text-xs lg:text-sm focus:outline-none focus:ring-2 focus:ring-purple-500"
                      >
                        {categoriesList.map((category) => (
                          <option
                            key={category}
                            value={category}
                            className="bg-slate-700"
                          >
                            {category === 'all' ? 'All Categories' : category}
                          </option>
                        ))}
                      </select> */}
                      <Select
                        isMulti
                        options={categoriesList}
                        value={categoriesList.filter(
                          (opt) =>
                            Array.isArray(props.categories) &&
                            props.categories.includes(opt.value)
                        )}
                        onChange={(selected: any) =>
                          props.setCategories(
                            selected ? selected.map((s: any) => s.value) : []
                          )
                        }
                        classNamePrefix="categories"
                        menuPortalTarget={document.body}
                        menuPosition="fixed"
                        styles={{
                          menuPortal: (base: any) => ({
                            ...base,
                            zIndex: 9999,
                          }),
                          control: (base: any) => ({
                            ...base,
                            backgroundColor: 'rgba(51,65,85,0.5)',
                            borderColor: 'rgba(168,85,247,0.3)',
                            borderRadius: '0.5rem',
                            padding: '2px',
                            color: '#fff',
                          }),
                          multiValue: (base: any) => ({
                            ...base,
                            backgroundColor: 'rgba(168,85,247,0.2)',
                          }),
                          multiValueLabel: (base: any) => ({
                            ...base,
                            color: '#d8b4fe',
                          }),
                          multiValueRemove: (base: any) => ({
                            ...base,
                            color: '#c084fc',
                            display: 'flex',
                            ':hover': {
                              backgroundColor: '#a855f7',
                              color: 'white',
                            },
                          }),
                          menu: (base: any) => ({
                            ...base,
                            backgroundColor: '#1e293b',
                          }),
                          option: (base: any, { isSelected }: any) => ({
                            ...base,
                            backgroundColor: isSelected
                              ? '#9333ea'
                              : 'transparent',
                            color: isSelected ? 'white' : '#f1f5f9',
                            ':hover': {
                              backgroundColor: '#7e22ce',
                              color: 'white',
                            },
                            zIndex: isSelected ? '999' : '999',
                          }),
                        }}
                      />
                    </div>
                  </div>

                  {(props.isHideContent ||
                    props.likes.length > 0 ||
                    props.networkFilter !== 'all' ||
                    props?.categories?.length > 0) && (
                    <div className="mt-4 pt-4 border-t border-purple-500/20">
                      <div className="flex items-center space-x-2 flex-wrap">
                        <span className="text-xs lg:text-sm text-gray-400">
                          Active filters:
                        </span>
                        {props.isHideContent && (
                          <span className="bg-purple-600/20 text-purple-300 px-2 py-1 rounded-full text-xs border border-purple-500/30">
                            Marked Done
                          </span>
                        )}
                        {props.likes.length > 0 && (
                          <span className="bg-pink-600/20 text-pink-300 px-2 py-1 rounded-full text-xs border border-pink-500/30">
                            Liked Posts
                          </span>
                        )}
                        {props.networkFilter !== 'all' && (
                          <span className="bg-cyan-600/20 text-cyan-300 px-2 py-1 rounded-full text-xs border border-cyan-500/30">
                            {props.networkFilter}
                          </span>
                        )}
                        {props.categories.length > 0 && (
                          <span className="bg-blue-600/20 text-blue-300 px-2 py-1 rounded-full text-xs border border-blue-500/30">
                            {props.categories.join(', ')}
                          </span>
                        )}
                        <button
                          onClick={() => {
                            props.setIsHideContent(false)
                            props.setLikes([])
                            props.setNetworkFilter('all')
                            props.setCategories([])
                          }}
                          className="text-xs text-gray-400 hover:text-gray-200 underline ml-2"
                        >
                          Clear all
                        </button>
                      </div>
                    </div>
                  )}
                </div>

                <div className="w-full">
                  {(props.statusData.instagram ||
                    props.statusData.youtube ||
                    props.statusData.reddit ||
                    props.statusData.tiktok ||
                    props.statusData.facebook) && (
                    <HitsTableScrapingStatus status={props.statusData} />
                  )}
                  {hits?.length === 0 ? (
                    <div className="col-span-full flex justify-center items-center py-10 w-full">
                      <div className="w-full bg-slate-800/60 backdrop-blur-xl rounded-xl shadow-xl border border-purple-500/20 px-6 py-4 hover:border-purple-400/40 transition-all duration-300 flex flex-col items-center text-center mb-10">
                        <ScreenSearchDesktopIcon
                          className="text-gray-600 opacity-90 mb-2"
                          style={{ fontSize: '84px' }}
                        />

                        <h4 className="text-gray-200 text-2xl font-semibold tracking-wide mb-1">
                          No results found
                        </h4>

                        <p
                          className={`text-gray-400 text-base max-w-md mx-auto leading-relaxed tracking-wide ${
                            props.statusData.instagram ||
                            props.statusData.reddit ||
                            props.statusData.youtube
                              ? 'animate-pulse'
                              : ''
                          }`}
                        >
                          <span>
                            {props.statusData.instagram ||
                            props.statusData.reddit ||
                            props.statusData.youtube
                              ? scrapingText
                              : emptyStateText}
                          </span>
                        </p>
                      </div>
                    </div>
                  ) : (
                    hits
                      ?.filter((x) => {
                        if (interactedOnly) {
                          return x.interactedWith
                        }
                        if (props.classificationTag.length > 0) {
                          return props.classificationTag.includes(
                            x.interaction.tag ?? ''
                          )
                        }
                        return true
                      })
                      ?.map((item: Hit, index: number) => {
                        const dateObject = new Date(Number(item?.date))
                        const displayDate = format(dateObject, 'd MMM y')
                        const hashtags = item.content?.match(/#\w+/g) ?? []
                        const bodyWithoutHashtags = item.content
                          ?.replace(/#\w+/g, '')
                          .trim()
                        return (
                          <div
                            key={index}
                            className="mt-5 bg-slate-800/60 backdrop-blur-xl rounded-xl shadow-xl border border-purple-500/20 hover:border-purple-400/40 transition-all duration-300"
                          >
                            <div className="p-4 lg:p-6">
                              <div className="flex items-start justify-between gap-2 mb-4">
                                <div className="flex items-center space-x-3 min-w-0 flex-1">
                                  <img
                                    src={
                                      item?.creator?.avatarUrl ??
                                      DEFAULT_AVATAR_URL
                                    }
                                    alt="Profile"
                                    className="w-10 h-10 lg:w-12 lg:h-12 rounded-full border-2 border-purple-500/30 flex-shrink-0"
                                  />
                                  <div className="min-w-0">
                                    <div className="flex items-center space-x-2">
                                      <span className="font-medium text-gray-100 truncate">
                                        {item.creator.name}
                                      </span>
                                      {item?.interactedWith && (
                                        <div className="w-4 h-4 bg-gradient-to-r from-cyan-400 to-blue-500 rounded-full flex items-center justify-center flex-shrink-0">
                                          <Check className="w-2 h-2 text-white" />
                                        </div>
                                      )}
                                    </div>
                                    <span className="text-sm text-gray-400">
                                      {displayDate}
                                    </span>
                                    <div className="grid grid-cols-3 gap-1 lg:flex lg:flex-wrap lg:items-center lg:gap-4 text-xs text-gray-400 mt-1">
                                      <span className="truncate">
                                        <strong className="text-gray-300 hidden sm:inline">
                                          FOLLOWERS{' '}
                                        </strong>
                                        {item?.interaction?.followers
                                          ? formatNumber(
                                              item?.interaction?.followers
                                            )
                                          : 0}
                                      </span>
                                      <span className="truncate">
                                        <strong className="text-gray-300 hidden sm:inline">
                                          FOLLOWING{' '}
                                        </strong>
                                        {item?.interaction?.following
                                          ? formatNumber(
                                              item?.interaction?.following
                                            )
                                          : 0}
                                      </span>
                                      <span className="truncate">
                                        <strong className="text-gray-300 hidden sm:inline">
                                          POSTS{' '}
                                        </strong>
                                        {item?.interaction?.postCount
                                          ? formatNumber(
                                              item?.interaction?.postCount
                                            )
                                          : 0}
                                      </span>
                                    </div>
                                  </div>
                                </div>

                                <div className="relative flex-shrink-0">
                                  <button
                                    ref={buttonRef}
                                    onClick={(e) => {
                                      e.stopPropagation()
                                      setOpen(open === item.id ? null : item.id)
                                    }}
                                    className="pointer inline-flex items-center p-2 text-sm font-medium text-center text-gray-900 bg-white rounded-lg hover:bg-gray-100 dark:text-white dark:bg-gray-800 dark:hover:bg-gray-700 dark:focus:ring-gray-600"
                                  >
                                    <MoreHorizontal className="w-5 h-5 text-gray-400 hover:text-purple-400 " />
                                  </button>

                                  {open === item.id && (
                                    <div
                                      ref={menuRef}
                                      className="absolute right-0 mt-2 w-44 bg-slate-800 text-gray-100 divide-y divide-gray-700 rounded-lg shadow-lg z-20"
                                    >
                                      <ul className="py-2 text-sm">
                                        {!item?.interactedWith && (
                                          <li>
                                            <button
                                              onClick={(e) => {
                                                e.stopPropagation()
                                                buttonclickHandler(item)
                                                setOpen(null)
                                              }}
                                              className="block w-full px-4 py-2 text-left hover:bg-gray-700"
                                            >
                                              Mark as Interacted
                                            </button>
                                          </li>
                                        )}
                                        <li>
                                          <button
                                            onClick={(e) => {
                                              e.stopPropagation()
                                              addArchive({
                                                variables: {
                                                  campaignId:
                                                    params.campaignId ?? '',
                                                  hitId: item.id,
                                                },
                                              })
                                                .then(() => {
                                                  setHits((prev) =>
                                                    prev.filter(
                                                      (h) => h.id !== item.id
                                                    )
                                                  )
                                                  setOpen(null)
                                                })
                                                .catch((err) =>
                                                  console.error(err)
                                                )
                                            }}
                                            className="block w-full px-4 py-2 text-left hover:bg-gray-700"
                                          >
                                            Hide Hit
                                          </button>
                                        </li>
                                      </ul>
                                    </div>
                                  )}
                                </div>
                              </div>
                              <p className="text-gray-200 mb-4 leading-relaxed">
                                {shortenString(bodyWithoutHashtags ?? '', 300)}
                              </p>
                              <div className="flex flex-wrap gap-2 mb-4">
                                {hashtags.slice(0, 3).map((hash, idx) => (
                                  <span
                                    key={idx}
                                    className="bg-gradient-to-r from-cyan-500/20 to-blue-500/20 text-cyan-300 border border-cyan-500/30 px-3 py-1 rounded-full text-sm font-medium hover:from-cyan-500/30 hover:to-blue-500/30 transition-all cursor-pointer"
                                  >
                                    {hash}
                                  </span>
                                ))}
                                {hashtags.length > 3 && (
                                  <span className="bg-gradient-to-r from-cyan-500/20 to-blue-500/20 text-cyan-300 border border-cyan-500/30 px-3 py-1 rounded-full text-sm font-medium hover:from-cyan-500/30 hover:to-blue-500/30 transition-all cursor-pointer">
                                    +{hashtags.length - 3}
                                  </span>
                                )}
                              </div>
                              <div className="bg-slate-900/50 rounded-lg p-4 mb-4 border border-purple-500/10">
                                <h4 className="font-medium text-purple-300 mb-2">
                                  SUMMARY OF CONTENT
                                </h4>
                                <p className="text-sm text-gray-300">
                                  {item.summary ?? 'No summary available'}
                                </p>
                              </div>
                              <div className="flex items-center justify-between flex-wrap gap-4 mb-4">
                                <div className="flex items-center space-x-4 lg:space-x-6">
                                  <button
                                    // onClick={() => handleLike(post.id as number)}
                                    className={`flex items-center space-x-2 transition-all duration-200 ${
                                      // likedPosts.has(post.id) ?
                                      'text-pink-400 scale-110'
                                      // : 'text-gray-400 hover:text-pink-400'
                                    }`}
                                  >
                                    <Heart
                                      className={`w-5 h-5 ${
                                        // likedPosts.has(post.id)
                                        'fill-current'
                                        // : ''
                                      }`}
                                    />
                                    <span className="text-sm font-medium">
                                      {formatLongNumber(
                                        item.interaction.positive
                                      )}
                                    </span>
                                  </button>
                                  <button className="flex items-center space-x-2 text-gray-400 hover:text-cyan-400 transition-colors">
                                    <MessageCircle className="w-5 h-5" />
                                    <span className="text-sm font-medium">
                                      {formatLongNumber(
                                        item?.interaction?.comment ?? 0
                                      )}
                                    </span>
                                  </button>
                                  <button className="flex items-center space-x-2 text-gray-400 hover:text-green-400 transition-colors">
                                    <Repeat2 className="w-5 h-5" />
                                  </button>
                                  <button
                                    className="flex items-center space-x-2 text-gray-400 hover:text-purple-400 transition-colors "
                                    // eslint-disable-next-line @typescript-eslint/no-misused-promises, @typescript-eslint/promise-function-async
                                    onClick={() =>
                                      shareCopyToClipboard(item.postURL, index)
                                    }
                                  >
                                    {shareCopiedStates[index] ? (
                                      <>
                                        <Check className="w-4 h-4" />
                                        <span>Copied!</span>
                                      </>
                                    ) : (
                                      <>
                                        <Share className="w-5 h-5 cursor-pointer" />
                                      </>
                                    )}
                                  </button>
                                  <button
                                    className="flex items-center space-x-2 text-gray-400 hover:text-blue-400 transition-colors"
                                    onClick={() => window.open(item.postURL, '_blank')}
                                    title="View original post"
                                  >
                                    <ExternalLink className="w-5 h-5 cursor-pointer" />
                                  </button>
                                </div>
                                <div className="flex space-x-2">
                                  <button
                                    className="bg-gradient-to-r cursor-pointer from-slate-700 to-slate-600 
                                        text-white px-3 lg:px-4 py-2 rounded-lg 
                                        text-xs lg:text-sm font-medium 
                                        hover:from-slate-600 hover:to-slate-500 
                                        transition-all duration-200 transform hover:scale-105
                                        disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:scale-100"
                                    disabled={
                                      (props.hitGenerationCounts[item.id] ??
                                        0) >= 3 ||
                                      generatingComment[item.id] ||
                                      commentLoading
                                    }
                                    onClick={() => {
                                      props.setHitGenerationCounts((prev) => ({
                                        ...prev,
                                        [item.id]:
                                          Number(
                                            props.hitGenerationCounts[
                                              item.id
                                            ] ?? 0
                                          ) + 1,
                                      }))
                                      void createHitGeneration({
                                        variables: {
                                          hitsId: item.id,
                                          campaignId: Number(params.campaignId),
                                          count:
                                            Number(
                                              props.hitGenerationCounts[
                                                item.id
                                              ] ?? 0
                                            ) + 1,
                                        },
                                      }).then((res) => {
                                        if (
                                          res.data?.createHitGeneration ===
                                          false
                                        ) {
                                          alert(
                                            'Generation limit reached or server rejected the request.'
                                          )
                                          return
                                        }

                                        void generateComment(
                                          hashtags,
                                          item.summary ?? '',
                                          item.id,
                                          item.content ?? ''
                                        )
                                      })
                                    }}
                                  >
                                    GENERATE
                                  </button>
                                  <button
                                    className="bg-gradient-to-r cursor-pointer from-purple-600 to-pink-600 text-white px-3 lg:px-4 py-2 rounded-lg text-xs lg:text-sm font-medium hover:from-purple-500 hover:to-pink-500 transition-all duration-200 transform hover:scale-105 shadow-lg"
                                    onClick={() => {
                                      void (async () => {
                                        if (item.interactedWith) return;
                                    
                                        const platform = item.platforms[0];
                                        const generatedComment = generatedComments[item.id] || lastComments?.[index] || '';
                                        
                                        if (platform === 'Instagram') {
                                          if (!generatedComment.trim()) {
                                            alert('Please generate a comment first');
                                            return;
                                          }
                                          
                                          const isInstalled = await checkInstalled();
                                          if (!isInstalled) {
                                            if (window.confirm('The Nalapod Comment Helper extension is required. Would you like to install it now?')) {
                                              window.open('https://chromewebstore.google.com/detail/gnabcdaipfdjejbidofbdnhfnoacbkec?utm_source=item-share-cb', '_blank');
                                            }
                                            return;
                                          }
                                          
                                          // Check rate limit before proceeding
                                          const rateLimitCheck = await checkRateLimit();
                                          if (!rateLimitCheck.allowed) {
                                            alert(rateLimitCheck.message);
                                            return;
                                          }
                                          
                                          // Show warning if commenting too quickly
                                          if (rateLimitCheck.warning) {
                                            console.warn('⚠️', rateLimitCheck.warning);
                                          }
                                          
                                          console.log('🚀 Instagram: calling extension');
                                          const success = await openInstagramReply(item.postURL, generatedComment);
                                          
                                          if (success && !item.interactedWith) {
                                            void addInteraction({
                                              variables: {
                                                campaignId: params.campaignId ?? '',
                                                hitId: item.id,
                                              },
                                            });
                                          }
                                          return;
                                        }
                                        
                                        if (['Facebook', 'TikTok'].includes(platform)) {
                                          if (!item.interactedWith) {
                                            void addInteraction({
                                              variables: {
                                                campaignId: params.campaignId ?? '',
                                                hitId: item.id,
                                              },
                                            });
                                          }
                                          window.open(item.postURL, '_blank');
                                          return;
                                        }
                                        
                                        setCurrentItemId(item);
                                        setValue(generatedComment);
                                        setIsRepliedModalOpen(true);
                                      })();
                                    }}
                                  >
                                    {item.interactedWith
                                      ? 'REPLIED'
                                      : 'REPLY →'}
                                  </button>
                                </div>
                              </div>
                              {(generatedComments[item.id] ||
                                lastComments?.[index]) && (
                                <div className="bg-gradient-to-r from-purple-900/30 to-pink-900/30 rounded-lg p-4 mb-4 border border-purple-500/20">
                                  {/* Comment Text */}
                                  <p className="text-sm text-gray-200">
                                    {commentLoading
                                      ? 'Loading...'
                                      : generatedComments[item.id] ||
                                        lastComments?.[index] ||
                                        'This content is amazing, I completely relate with so much of what you said especially the way that true crime brings so much curiosity to our lives.'}
                                  </p>

                                  <div className="flex justify-between items-center">
                                    {/* Copy Button */}
                                    <button
                                      onClick={() =>
                                        // eslint-disable-next-line no-void
                                        void copyToClipboard(
                                          generatedComments[item.id] ||
                                            lastComments?.[index] ||
                                            '',
                                          index
                                        )
                                      }
                                      className="mt-2 flex items-center space-x-2 text-sm text-purple-400 hover:text-purple-300 transition-colors"
                                    >
                                      {copiedStates[index] ? (
                                        <>
                                          <Check className="w-4 h-4" />
                                          <span>Copied!</span>
                                        </>
                                      ) : (
                                        <>
                                          <Copy className="w-4 h-4" />
                                          <span>Copy to Clipboard</span>
                                        </>
                                      )}
                                    </button>

                                    {/* Edit Button */}
                                    <button
                                      onClick={() =>
                                        handleEditComment(
                                          item.id,
                                          generatedComments[item.id] ||
                                            lastComments?.[index] ||
                                            ''
                                        )
                                      }
                                      className="flex items-center space-x-2 text-sm text-cyan-400 hover:text-cyan-300 transition-colors"
                                    >
                                      <svg
                                        className="w-4 h-4"
                                        fill="none"
                                        stroke="currentColor"
                                        viewBox="0 0 24 24"
                                      >
                                        <path
                                          strokeLinecap="round"
                                          strokeLinejoin="round"
                                          strokeWidth={2}
                                          d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
                                        />
                                      </svg>
                                      <span>Edit</span>
                                    </button>
                                  </div>
                                </div>
                              )}
                            </div>
                          </div>
                        )
                      })
                  )}

                  {/* Edit Comment Modal */}
                  <Modal
                    open={isEditModalOpen}
                    onClose={() => {
                      setEditLoading(false)
                      setEditValue('')
                      setEditErrorMessage(null)
                      setEditingCommentId(null)
                      setIsEditModalOpen(false)
                    }}
                  >
                    <div className="min-h-screen flex items-center justify-center px-4">
                      <div className="w-full max-w-lg bg-slate-800/60 backdrop-blur-xl rounded-xl shadow-xl border border-purple-500/20 p-6 relative text-white">
                        {/* Close button */}
                        <button
                          onClick={() => {
                            setEditLoading(false)
                            setEditValue('')
                            setEditErrorMessage(null)
                            setEditingCommentId(null)
                            setIsEditModalOpen(false)
                          }}
                          className="absolute top-4 right-4 text-white/60 hover:text-white bg-white/10 p-1 rounded-full transition z-50"
                        >
                          <CloseIcon />
                        </button>

                        {/* Header */}
                        <div className="flex items-center space-x-2 mb-4">
                          <svg
                            className="w-5 h-5 text-cyan-400"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth={2}
                              d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
                            />
                          </svg>
                          <h2 className="text-lg font-semibold text-cyan-300">
                            Edit Comment
                          </h2>
                        </div>

                        {/* Textarea */}
                        <div className="mb-4">
                          <textarea
                            className="w-full bg-slate-900/50 border border-cyan-500/20 rounded-lg p-3 text-white resize-none focus:outline-none focus:ring-2 focus:ring-cyan-500"
                            placeholder="Edit your comment here..."
                            rows={4}
                            value={editValue}
                            onChange={(e) => setEditValue(e.target.value)}
                            disabled={editLoading}
                            maxLength={10000}
                          />
                          {editErrorMessage && (
                            <div className="flex items-center gap-2 mt-2 text-red-500 text-sm">
                              <ErrorIcon fontSize="small" />
                              {editErrorMessage}
                            </div>
                          )}
                        </div>

                        {/* Action Buttons */}
                        <div className="flex justify-end space-x-3">
                          <button
                            onClick={() => {
                              setEditLoading(false)
                              setEditValue('')
                              setEditErrorMessage(null)
                              setEditingCommentId(null)
                              setIsEditModalOpen(false)
                            }}
                            className="px-4 py-2 border border-gray-500 text-gray-300 rounded-lg hover:bg-gray-600/20 transition disabled:opacity-50"
                            disabled={editLoading}
                          >
                            Cancel
                          </button>
                          <button
                            // eslint-disable-next-line @typescript-eslint/no-misused-promises
                            onClick={handleEditSave}
                            disabled={
                              editLoading || editValue.trim().length === 0
                            }
                            className="bg-gradient-to-r from-cyan-600 to-blue-600 px-4 py-2 rounded-lg text-white text-sm font-medium hover:from-cyan-500 hover:to-blue-500 transition disabled:opacity-50"
                          >
                            {editLoading ? 'Saving...' : 'Save Changes'}
                          </button>
                        </div>
                      </div>
                    </div>
                  </Modal>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <TableStyle.TableWrapper
          sx={{
            borderRadius: '0px',
            backgroundColor: '#0d0d0d',
          }}
        > */}
      {/* <TableStyle.TableWrapperResponsive
            sx={{
              borderRadius: '0px',
              backgroundColor: '#0d0d0d',
            }}
          >
            <TableStyle.TableContainerStyle
              sx={{
                borderRadius: '0px',
                backgroundColor: '#0d0d0d',
              }}
            >
              {(props.statusData.instagram ||
                props.statusData.youtube ||
                props.statusData.reddit ||
                props.statusData.tiktok ||
                props.statusData.facebook) && (
                <HitsTableScrapingStatus status={props.statusData} />
              )}
              {props?.data?.hits?.hits?.length === 0 ? (
                <EmptyState statusData={props.statusData} />
              ) : (
                props?.data?.hits?.hits
                  ?.filter((x) => {
                    if (interactedOnly) {
                      return x.interactedWith
                    }
                    if (props.classificationTag.length > 0) {
                      return props.classificationTag.includes(
                        x.interaction.tag ?? ''
                      )
                    }
                    return true
                  })
                  ?.map((item: Hit, index: number) => {
                    const dateObject = new Date(Number(item?.date))
                    const displayDate = format(dateObject, 'd MMM y')
                    const hashtags = item.content?.match(/#\w+/g) ?? []
                    const bodyWithoutHashtags = item.content
                      ?.replace(/#\w+/g, '')
                      .trim()
                    return (
                      <Box
                        key={index}
                        sx={{
                          display: 'flex',
                          gap: '40px',
                          flexWrap: 'wrap',
                          marginBottom: '30px',
                        }}
                      >
                        <Box sx={{ display: 'flex', gap: '21px' }}>
                          <ProfileImage
                            src={item?.creator?.avatarUrl ?? DEFAULT_AVATAR_URL}
                            alt="Profile"
                          />
                          <CommentCard>
                            <CommentHeader>
                              <CommentContent>
                                <Box
                                  sx={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    marginBottom: '16px',
                                  }}
                                >
                                  <UserHandle
                                    sx={{
                                      textTransform: 'uppercase',
                                    }}
                                  >
                                    <SocialMediaIcon
                                      platformName={item?.platforms[0]}
                                      width={20}
                                    />
                                    {`@${item.creator.name}`}
                                  </UserHandle>
                                  <Box
                                    sx={{
                                      display: 'flex',
                                      gap: '10px',
                                    }}
                                  >
                                    <TimeStamp>{displayDate}</TimeStamp>
                                    <img
                                      src={Icons.check}
                                      alt=""
                                      width={24}
                                      height={24}
                                    />
                                  </Box>
                                </Box>
                                <CommentText
                                  sx={{
                                    marginBottom: '20px',
                                  }}
                                >
                                  {shortenString(
                                    bodyWithoutHashtags ?? '',
                                    300
                                  )}
                                </CommentText>
                                <Box
                                  sx={{
                                    display: 'flex',
                                    gap: '10px',
                                    flexWrap: 'wrap',
                                    marginBottom: '17px',
                                    marginLeft: '27px',
                                  }}
                                >
                                  {hashtags.slice(0, 3).map((hash) => (
                                    <HashTag key={hash}>{hash}</HashTag>
                                  ))}
                                  {hashtags.length > 3 && (
                                    <HashTag>+{hashtags.length - 3}</HashTag>
                                  )}
                                </Box>
                                <Box
                                  sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    gap: '10px',
                                    marginLeft: '27px',
                                  }}
                                >
                                  <SummaryText>Summary of content</SummaryText>
                                  <SummaryDetailsText>
                                    {item.summary ?? 'No summary available'}
                                  </SummaryDetailsText>
                                </Box>
                              </CommentContent>
                            </CommentHeader>
                            <Box
                              sx={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                padding: '16px',
                                marginLeft: '27px',
                              }}
                            >
                              <Box>
                                <SocialStats>
                                  <Box className="stat">
                                    <img
                                      src={Icons.heart}
                                      alt="heart"
                                      width={27}
                                      height={27}
                                    />
                                    {formatLongNumber(
                                      item.interaction.positive
                                    )}
                                  </Box>
                                  <Box className="stat">
                                    <img
                                      src={Icons.retweet}
                                      alt="retweet"
                                      width={27}
                                      height={27}
                                    />
                                    {formatLongNumber(
                                      item?.interaction?.shared ?? 0
                                    )}
                                  </Box>
                                </SocialStats>
                              </Box>
                              <Box
                                sx={{
                                  display: 'flex',
                                  gap: '19px',
                                }}
                              >
                                <GenerateButton
                                  variant="contained"
                                  disabled={
                                    (props.hitGenerationCounts[item.id] ?? 0) >=
                                      3 ||
                                    generatingComment[item.id] ||
                                    commentLoading
                                  }
                                  onClick={() => {
                                    props.setHitGenerationCounts((prev) => ({
                                      ...prev,
                                      [item.id]:
                                        Number(
                                          props.hitGenerationCounts[item.id] ??
                                            0
                                        ) + 1,
                                    }))
                                    void createHitGeneration({
                                      variables: {
                                        hitsId: item.id,
                                        campaignId: Number(params.campaignId),
                                        count:
                                          Number(
                                            props.hitGenerationCounts[
                                              item.id
                                            ] ?? 0
                                          ) + 1,
                                      },
                                    }).then((res) => {
                                      // ✅ Check if response was false
                                      if (
                                        res.data?.createHitGeneration === false
                                      ) {
                                        // ❌ Show error (you can use your UI library or native alert)
                                        alert(
                                          'Generation limit reached or server rejected the request.'
                                        )
                                        return
                                      }

                                      void generateComment(
                                        hashtags,
                                        item.summary ?? '',
                                        item.id
                                      )
                                    })
                                  }}
                                >
                                  GENERATE
                                </GenerateButton>
                                <ReplyButton
                                  variant="contained"
                                  className={
                                    item.interactedWith ? 'replied' : 'no-reply'
                                  }
                                  onClick={() => {
                                    if (item.interactedWith) return
                                    if (
                                      [
                                        'Instagram',
                                        'Facebook',
                                        'TikTok',
                                      ].includes(item.platforms[0])
                                    ) {
                                      if (!item.interactedWith) {
                                        addInteraction({
                                          variables: {
                                            campaignId: params.campaignId ?? '',
                                            hitId: item.id,
                                          },
                                        }).catch((e) => {
                                          console.log(e)
                                        })
                                      }
                                      window.open(item.postURL, '_blank')
                                    } else {
                                      setCurrentItemId(item)
                                      setIsRepliedModalOpen(!isRepliedModalOpen)
                                    }
                                  }}
                                >
                                  {item.interactedWith ? (
                                    <React.Fragment key="replied-button">
                                      <ReplyIcon
                                        src={Icons.gCheck}
                                        alt="Replied"
                                      />
                                      REPLIED
                                    </React.Fragment>
                                  ) : (
                                    <React.Fragment key="reply-button">
                                      REPLY
                                      <ReplyIcon
                                        src={Icons.wRightArrow}
                                        alt="Reply"
                                      />
                                    </React.Fragment>
                                  )}
                                </ReplyButton>
                              </Box>
                            </Box>
                            {generatedComments[item.id] && (
                              <ReplySection>
                                <CommentText
                                  sx={{
                                    maxWidth: '450px',
                                  }}
                                >
                                  {commentLoading
                                    ? 'Loading...'
                                    : generatedComments[item.id] ||
                                      'This content is amazing, I completely relate with so much of what you said especially the way that true crime brings so much curiosity to our lives.'}
                                </CommentText>
                                <Box
                                  sx={{
                                    display: 'flex',
                                    justifyContent: 'flex-end',
                                    alignItems: 'center',
                                    cursor: 'pointer',
                                  }}
                                  // eslint-disable-next-line @typescript-eslint/no-misused-promises, @typescript-eslint/promise-function-async
                                  onClick={() =>
                                    copyToClipboard(
                                      generatedComments[item.id],
                                      index
                                    )
                                  }
                                >
                                  <Box
                                    sx={{
                                      color: '#292929',
                                      fontSize: '17px',
                                    }}
                                  >
                                    {copiedStates[index]
                                      ? 'Copied!'
                                      : 'Copy to Clipboard'}
                                  </Box>
                                  <Box>
                                    <img
                                      src={
                                        copiedStates[index]
                                          ? Icons.gCheck
                                          : Icons.Clipboard
                                      }
                                      alt="copy"
                                      width={copiedStates[index] ? 20 : 30}
                                      height={copiedStates[index] ? 20 : 30}
                                    />
                                  </Box>
                                </Box>
                              </ReplySection>
                            )}
                          </CommentCard>
                        </Box>
                        <Box
                          sx={{
                            width: '100%',
                            maxWidth: '196px',
                          }}
                        >
                          <Box
                            sx={{
                              display: 'flex',
                              gap: '15px',
                              marginBottom: '10px',
                            }}
                          >
                            <ProfileImage
                              src={
                                item?.creator?.avatarUrl ?? DEFAULT_AVATAR_URL
                              }
                              alt="Profile"
                            />
                            <Box
                              sx={{
                                fontSize: '21px',
                                fontWeight: '400',
                                fontFamily: 'inter',
                              }}
                            >{`@${item.creator.name}`}</Box>
                          </Box>
                          <Box
                            sx={{
                              fontSize: '12px',
                              fontWeight: '400',
                              color: '#c1c1c1',
                              marginBottom: '3px',
                            }}
                          >
                            {item?.platforms[0]}
                          </Box>
                          <Box
                            sx={{
                              fontSize: '14px',
                              fontWeight: '400',
                              marginBottom: '20px',
                            }}
                          >
                            Bio here
                          </Box>
                          <Box
                            sx={{
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'space-between',
                              marginBottom: '32px',
                            }}
                          >
                            <Box
                              sx={{
                                fontSize: '20px',
                                fontWeight: '400',
                              }}
                            >
                              FOLLOWERS
                            </Box>
                            <Box
                              sx={{
                                fontSize: '20px',
                                fontWeight: '700',
                                color: '#bfbfbf',
                              }}
                            >
                              12k
                            </Box>
                          </Box>
                          <Box
                            sx={{
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'space-between',
                              marginBottom: '32px',
                            }}
                          >
                            <Box
                              sx={{
                                fontSize: '20px',
                                fontWeight: '400',
                              }}
                            >
                              FOLLOWING
                            </Box>
                            <Box
                              sx={{
                                fontSize: '20px',
                                fontWeight: '700',
                                color: '#bfbfbf',
                              }}
                            >
                              1.2k
                            </Box>
                          </Box>
                          <Box
                            sx={{
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'space-between',
                            }}
                          >
                            <Box
                              sx={{
                                fontSize: '20px',
                                fontWeight: '400',
                              }}
                            >
                              POSTS
                            </Box>
                            <Box
                              sx={{
                                fontSize: '20px',
                                fontWeight: '700',
                                color: '#bfbfbf',
                              }}
                            >
                              61
                            </Box>
                          </Box>
                        </Box>
                      </Box>
                    )
                  })
              )}
            </TableStyle.TableContainerStyle>
          </TableStyle.TableWrapperResponsive> */}
      {/* </TableStyle.TableWrapper> */}
      {/* </Fade> */}
      {/* <Modal
        open={isRepliedModalOpen}
        onClose={() => {
          setIsLoading(false)
          setValue('')
          setErrorMessage(null)
          setCurrentItemId(null)
          setIsRepliedModalOpen(false)
        }}
      >
        <Box
          sx={{
            position: 'absolute' as 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: '100%',
            maxWidth: '600px',
            bgcolor: Colors.backgroundDark,
            boxShadow: '0 8px 32px rgba(0, 0, 0, 0.4)',
            padding: '24px',
            borderRadius: '12px',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            color: '#ffffff',
          }}
        >
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'flex-end',
              alignItems: 'end',
              width: '100%',
              marginBottom: '20px',
            }}
          >
            <CloseIcon
              sx={{
                cursor: 'pointer',
                color: 'rgba(255, 255, 255, 0.6)',
                transition: 'all 0.2s ease-in-out',
                padding: '4px',
                borderRadius: '50%',
                '&:hover': {
                  color: '#ffffff',
                  backgroundColor: 'rgba(255, 255, 255, 0.1)',
                },
              }}
              onClick={(e) => {
                e.preventDefault()
                e.stopPropagation()
                setIsLoading(false)
                setValue('')
                setErrorMessage(null)
                setCurrentItemId(null)
                setIsRepliedModalOpen(false)
              }}
            />
          </Box>
          <HitModalStyle.TitleWrapper>
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
              }}
            >
              <HitModalStyle.ChatIconStyle />
              <HitModalStyle.SectionTitle>Respond</HitModalStyle.SectionTitle>
            </div>
            <Button
              variant="outlined"
              color="success"
              disabled={responseLoading || Boolean(data)}
              onClick={() => {
                getResponse({
                  variables: {
                    platform: currentItemId?.platforms[0] as Platform,
                    videoId: currentItemId?.id,
                    content: currentItemId?.content,
                  },
                }).catch((e) => console.log(e))
              }}
            >
              Recommend response
            </Button>
          </HitModalStyle.TitleWrapper>
          <div
            style={{
              display: 'flex',
              width: '100%',
              justifyContent: 'center',
              paddingBottom: '10px',
            }}
          >
            {responseLoading && <CircularProgress />}
            {responses && !responseLoading && (
              <div
                style={{
                  width: '100%',
                }}
              >
                <List
                  component="nav"
                  sx={{
                    bgcolor: 'grey.900',
                    borderRadius: '4px',
                    boxShadow: '0px 2px 4px rgba(255, 255, 255, 0.1)',
                    color: 'grey.300',
                  }}
                >
                  <ListItem
                    button
                    onClick={() => setValue(responses?.comment1 ?? value)}
                    sx={{
                      '&:hover': {
                        bgcolor: 'grey.800',
                      },
                    }}
                  >
                    <ListItemText
                      primary={responses?.comment1}
                      primaryTypographyProps={{ color: 'inherit' }}
                    />
                  </ListItem>
                  <Divider sx={{ bgcolor: 'grey.700' }} />
                  <ListItem
                    button
                    divider
                    onClick={() => {
                      setValue(responses?.comment2 ?? value)
                    }}
                    sx={{
                      '&:hover': {
                        bgcolor: 'grey.800',
                      },
                    }}
                  >
                    <ListItemText
                      primary={responses?.comment2}
                      primaryTypographyProps={{ color: 'inherit' }}
                    />
                  </ListItem>
                  <ListItem
                    button
                    onClick={() => setValue(responses?.comment3 ?? value)}
                    sx={{
                      '&:hover': {
                        bgcolor: 'grey.800',
                      },
                    }}
                  >
                    <ListItemText
                      primary={responses?.comment3}
                      primaryTypographyProps={{ color: 'inherit' }}
                    />
                  </ListItem>
                </List>
              </div>
            )}
            {!responses && data && (
              <Alert severity="info">
                We couldn&apos;t recommend any responses
              </Alert>
            )}
            {error && (
              <Alert severity="error">
                Something went wrong, please try again!
              </Alert>
            )}
          </div>
          <CommentSection
            sx={{
              width: '100%',
            }}
          >
            <CommentInput
              placeholder="Write your response here..."
              multiline
              rows={4}
              disabled={loading}
              value={value}
              onChange={(e) => setValue(e.target.value)}
              inputProps={{ maxLength: 10000 }}
            />
            {errorMessage && (
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px',
                  marginTop: '8px',
                }}
              >
                <ErrorIcon
                  sx={{
                    color: '#ff6b6b',
                    fontSize: '20px',
                  }}
                />
                <Typography
                  sx={{
                    color: '#ff6b6b',
                    fontSize: '14px',
                  }}
                >
                  {errorMessage}
                </Typography>
              </div>
            )}
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'flex-end',
                marginTop: '20px',
              }}
            >
              <ReplyButtons
                onClick={() => handleRespond(currentItemId)}
                disabled={loading || value.trim().length === 0}
              >
                REPLY
                <span className="arrow">→</span>
              </ReplyButtons>
            </Box>
          </CommentSection>
        </Box>
      </Modal> */}

      <Modal
        open={isRepliedModalOpen}
        onClose={() => {
          setIsLoading(false)
          setValue('')
          setErrorMessage(null)
          setCurrentItemId(null)
          setIsRepliedModalOpen(false)
        }}
      >
        <div className="min-h-screen flex items-center justify-center px-4">
          <div className="w-full max-w-xl bg-slate-800/60 backdrop-blur-xl rounded-xl shadow-xl border border-purple-500/20 p-6 relative text-white">
            {/* Close button */}
            <button
              onClick={(e) => {
                e.preventDefault()
                e.stopPropagation()
                setIsLoading(false)
                setValue('')
                setErrorMessage(null)
                setCurrentItemId(null)
                setIsRepliedModalOpen(false)
              }}
              className="absolute top-2 right-2 text-white/60 hover:text-white bg-white/10 p-1 rounded-full transition z-50"
            >
              <CloseIcon />
            </button>
            {/* Header */}
            <div className="flex items-center space-x-2 mb-4">
              <HitModalStyle.ChatIconStyle />
              <h2 className="text-lg font-semibold text-purple-300">
                Respond
              </h2>
            </div>

            {/* Recommended Responses */}
            <div className="mb-4 flex flex-col items-center">
              {responseLoading && (
                <div className="flex justify-center w-full my-4">
                  <CircularProgress />
                </div>
              )}

              {responses && !responseLoading && (
                <div className="bg-slate-900/50 rounded-lg border border-purple-500/10 p-2 space-y-1 w-full">
                  {[
                    responses.comment1,
                    responses.comment2,
                    responses.comment3,
                  ].map(
                    (c, idx) =>
                      c && (
                        <button
                          key={idx}
                          className="w-full text-left px-3 py-2 rounded hover:bg-slate-700 transition"
                          onClick={() => setValue(c)}
                        >
                          {c}
                        </button>
                      )
                  )}
                </div>
              )}

              {!responses && data && (
                <Alert severity="info" className="w-full mt-2">
                  We couldn&apos;t recommend any responses
                </Alert>
              )}

              {error && (
                <Alert severity="error" className="w-full mt-2">
                  Something went wrong!
                </Alert>
              )}
            </div>

            {/* Textarea */}
            <div className="mb-4">
              <textarea
                className="w-full bg-slate-900/50 border border-purple-500/20 rounded-lg p-3 text-white resize-none focus:outline-none focus:ring-2 focus:ring-purple-500"
                placeholder="Write your response here..."
                rows={4}
                value={value}
                onChange={(e) => setValue(e.target.value)}
                disabled={loading}
                maxLength={10000}
              />
              {errorMessage && (
                <div className="flex items-center gap-2 mt-2 text-red-500 text-sm">
                  <ErrorIcon fontSize="small" />
                  {errorMessage}
                </div>
              )}
            </div>

            {/* Reply Button */}
            <div className="flex justify-end">
              <button
                onClick={() => handleRespond(currentItemId)}
                disabled={loading || value.trim().length === 0}
                className="bg-gradient-to-r from-purple-600 to-pink-600 px-4 py-2 rounded-lg text-white text-sm font-medium hover:from-purple-500 hover:to-pink-500 transition disabled:opacity-50"
              >
                REPLY
              </button>
            </div>
          </div>
        </div>
      </Modal>
      {bulkProgress && (
        <div className="fixed bottom-4 right-4 bg-purple-600 text-white px-6 py-3 rounded-lg shadow-lg z-50">
          <div className="flex items-center space-x-3">
            <CircularProgress size={20} className="text-white" />
            <span>{bulkProgress}</span>
          </div>
        </div>
      )}

      {/* <Modal
        open={isRepliedModalOpen}
        onClose={() => {
          setIsLoading(false)
          setValue('')
          setErrorMessage(null)
          setCurrentItemId(null)
          setIsRepliedModalOpen(false)
        }}
      >
        <div className="min-h-screen flex items-center justify-center px-4">
          <div className="w-full max-w-lg bg-slate-800/60 backdrop-blur-xl rounded-xl shadow-xl border border-purple-500/20 p-6 relative text-white">
            <button
              onClick={(e) => {
                e.preventDefault()
                e.stopPropagation()
                setIsLoading(false)
                setValue('')
                setErrorMessage(null)
                setCurrentItemId(null)
                setIsRepliedModalOpen(false)
              }}
              className="absolute top-4 right-4 text-white/60 hover:text-white bg-white/10 p-1 rounded-full transition"
            >
              <CloseIcon />
            </button>

            <div className="flex items-center justify-between mb-4">
              <div className="flex items-center space-x-2">
                <HitModalStyle.ChatIconStyle />
                <h2 className="text-lg font-semibold text-purple-300">
                  Respond
                </h2>
              </div>
              <button
                className="px-3 py-1 border border-green-500 text-green-400 rounded-lg hover:bg-green-600/20 transition disabled:opacity-50"
                disabled={responseLoading || Boolean(data)}
                onClick={() => {
                  getResponse({
                    variables: {
                      platform: currentItemId?.platforms[0] as Platform,
                      videoId: currentItemId?.id,
                      content: currentItemId?.content,
                    },
                  }).catch(console.log)
                }}
              >
                Recommend Response
              </button>
            </div>

            <div className="mb-4">
              {responseLoading && <CircularProgress />}
              {responses && !responseLoading && (
                <div className="bg-slate-900/50 rounded-lg border border-purple-500/10 p-2 space-y-1">
                  {[
                    responses.comment1,
                    responses.comment2,
                    responses.comment3,
                  ].map(
                    (c, idx) =>
                      c && (
                        <button
                          key={idx}
                          className="w-full text-left px-3 py-2 rounded hover:bg-slate-700 transition"
                          onClick={() => setValue(c)}
                        >
                          {c}
                        </button>
                      )
                  )}
                </div>
              )}
              {!responses && data && (
                <Alert severity="info">
                  We couldn&apos;t recommend any responses
                </Alert>
              )}
              {error && <Alert severity="error">Something went wrong!</Alert>}
            </div>

            <div className="mb-4">
              <textarea
                className="w-full bg-slate-900/50 border border-purple-500/20 rounded-lg p-3 text-white resize-none focus:outline-none focus:ring-2 focus:ring-purple-500"
                placeholder="Write your response here..."
                rows={4}
                value={value}
                onChange={(e) => setValue(e.target.value)}
                disabled={loading}
                maxLength={10000}
              />
              {errorMessage && (
                <div className="flex items-center gap-2 mt-2 text-red-500 text-sm">
                  <ErrorIcon fontSize="small" />
                  {errorMessage}
                </div>
              )}
            </div>

            <div className="flex justify-end">
              <button
                onClick={() => handleRespond(currentItemId)}
                disabled={loading || value.trim().length === 0}
                className="bg-gradient-to-r from-purple-600 to-pink-600 px-4 py-2 rounded-lg text-white text-sm font-medium hover:from-purple-500 hover:to-pink-500 transition disabled:opacity-50"
              >
                REPLY
              </button>
            </div>
          </div>
        </div>
      </Modal> */}
    </>
  )
}
